<template lang="pug">
  section.percentages
    .col(v-for="(percentage, index) in percentages" :key="index")
      h2 {{percentage.title}}
        small {{percentage.small}}
      p {{percentage.description}}
</template>

<script>
export default {
  props: {
    percentages: Array
  }
}
</script>
<style lang="scss" scoped>
  .percentages{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    @media (max-width: 1100px){
      grid-template-columns: repeat(1, 1fr);
    }
    grid-gap: 2rem;
    padding: 3rem 0;
    border-top: 5px solid $blue;
    border-bottom: 5px solid $blue;
    position: relative;
    &:before,
    &:after{
      position: absolute;
      content: '';
      width: 100%;
      left: 0;
      border-bottom: 2px solid $blue;
    }
    &:before{
      top: 5px;
    }
    &:after{
      bottom: 5px;
    }
  }
  .col{
    text-align: center;
  }
  h2{
    font-size: 6rem;
    letter-spacing: -3px;
    line-height: 3.5rem;
    padding-bottom: 1rem;
    position: relative;
    margin-bottom: 1rem;
    small{
      font-size: 2rem;
      font-weight: normal;
      display: block;
      letter-spacing: -1px;
    }
    &:after{
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 60%;
      border: 6px solid $yellow;
    }
  }
</style>

